export const centerOnAlden:[number, number] = [-78.49512093768763,42.90425];